export const ru = {
    add_bonus_card: 'Добавить карту лояльности',
    empty_description: 'Чтобы получать бонусы даже в командировке',
    empty_title: 'Добавьте карты лояльности',
};
